/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateReportScheduleRequest } from '../../models/create-report-schedule-request';
import { ReportScheduleDto } from '../../models/report-schedule-dto';

export interface ReportSchedulesPost$Plain$Params {
      body?: CreateReportScheduleRequest
}

export function reportSchedulesPost$Plain(http: HttpClient, rootUrl: string, params?: ReportSchedulesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportScheduleDto>> {
  const rb = new RequestBuilder(rootUrl, reportSchedulesPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReportScheduleDto>;
    })
  );
}

reportSchedulesPost$Plain.PATH = '/report-schedules';
